
      var _circle, _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
const SvgCallIcon3X = props => /*#__PURE__*/React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  width: 63,
  height: 60,
  viewBox: "-4 -4 28 28",
  transform: "rotate(-90)"
}, props), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
  cx: 10,
  cy: 10,
  r: 12,
  fill: "var(--theme-primary, #810ea9)"
})), _path || (_path = /*#__PURE__*/React.createElement("path", {
  fill: "#fff",
  d: "M5.77 2.5q1.455.998 2.655 2.332c1.103 1.215.45 2.04-.33 3.12a.585.585 0 0 0 0 .675q1.313 1.815 3.075 3.015a.473.473 0 0 0 .637-.09q.713-.862 1.718-.885a1.163 1.125 61.1 0 1 .712.218q1.733 1.252 2.663 2.64a1.68 1.672-39.5 0 1-.203 2.115q-2.415 2.422-5.76.945-6.27-2.783-8.437-9.233V5.777Q2.987 3.572 4.728 2.5zm1.478 9.938c1.965 1.95 5.58 4.634 8.325 2.392a.54.54 0 0 0 .037-.795l-1.748-1.748a.592.585 44.7 0 0-.832 0l-.945.945a.637.622-54.2 0 1-.728.12Q10.022 12.7 8.5 11.185 6.97 9.67 6.302 8.335a.638.622-36.2 0 1 .12-.728l.938-.952a.593.585 44.9 0 0 0-.832L5.597 4.09a.54.54 0 0 0-.795.045c-2.22 2.76.488 6.36 2.446 8.303"
})));

      const __svgRaw = "<svg xmlns=\"http://www.w3.org/2000/svg\" width=\"63\" height=\"60\" viewBox=\"-4 -4 28 28\" version=\"1.1\" xmlns:xlink=\"http://www.w3.org/1999/xlink\" transform=\"matrix(-1.8369701987210297e-16,-1,1,-1.8369701987210297e-16,0,0)\">\r\n  <circle cx=\"10\" cy=\"10\" r=\"12\" fill=\"var(--theme-primary, #810ea9)\" />\r\n  \r\n  <g transform=\"translate(10, 10) scale(0.75) translate(-10, -10)\">\r\n    <path fill=\"white\" d=\"M4.36 0Q6.3 1.33 7.9 3.11c1.47 1.62.6 2.72-.44 4.16a.78.78 0 0 0 0 .9q1.75 2.42 4.1 4.02a.63.63 0 0 0 .85-.12q.95-1.15 2.29-1.18a1.55 1.5 61.1 0 1 .95.29q2.31 1.67 3.55 3.52a2.24 2.23-39.5 0 1-.27 2.82q-3.22 3.23-7.68 1.26Q2.89 15.07 0 6.47v-2.1Q.65 1.43 2.97 0zm1.97 13.25c2.62 2.6 7.44 6.18 11.1 3.19a.72.72 0 0 0 .05-1.06l-2.33-2.33a.79.78 44.7 0 0-1.11 0l-1.26 1.26a.85.83-54.2 0 1-.97.16Q10.03 13.6 8 11.58q-2.04-2.02-2.93-3.8a.85.83-36.2 0 1 .16-.97l1.25-1.27a.79.78 44.9 0 0 0-1.11L4.13 2.12a.72.72 0 0 0-1.06.06c-2.96 3.68.65 8.48 3.26 11.07\"></path>\r\n  </g>\r\n</svg>\r\n";

      function __resolveCssVarsInSvg(svgMarkup) {
        if (typeof window === 'undefined' || !document?.documentElement) {
          return svgMarkup;
        }

        const htmlEl = document.documentElement;
        const bodyEl = document.body;

        function __readCustomProperty(name) {
          let v = getComputedStyle(htmlEl).getPropertyValue(name).trim();
          if (!v && bodyEl) {
            v = getComputedStyle(bodyEl).getPropertyValue(name).trim();
          }
          return v;
        }

        function __expandVarToken(fullMatch, seen) {
          if (!seen) seen = new Set();
          const m = String(fullMatch)
            .trim()
            .match(/^var\(\s*(--[^),\s]+)(?:\s*,\s*([^)]+))?\s*\)$/i);
          if (!m) return fullMatch;
          const varName = m[1];
          const fallbackRaw = m[2] != null ? String(m[2]).trim() : '';
          if (seen.has(varName)) {
            return fallbackRaw || fullMatch;
          }
          seen.add(varName);
          let specified = __readCustomProperty(varName);
          if (!specified) {
            return fallbackRaw || fullMatch;
          }
          specified = specified.trim();
          if (/^var\s*\(/i.test(specified)) {
            return __expandVarToken(specified, seen) || fallbackRaw || fullMatch;
          }
          return specified || fallbackRaw || fullMatch;
        }

        return svgMarkup.replace(
          /var\(\s*(--[^),\s]+)(?:\s*,\s*([^)]+))?\s*\)/gi,
          (fullMatch) => __expandVarToken(fullMatch, new Set())
        );
      }

      function __getSvg() {
        return __resolveCssVarsInSvg(__svgRaw);
      }

      function __getBg() {
        const resolved =__resolveCssVarsInSvg(__svgRaw);

        const encoded = encodeURIComponent(resolved)
          .replace(/'/g, '%27')
          .replace(/"/g, '%22');
        return "url('data:image/svg+xml;charset=utf-8," + encoded + "')"; }

      export default Object.assign(
        new String(__webpack_public_path__ + "Assets/call-icon@3x.5734af434a53c364ae8e3bca03bd7104.svg"),
        {
          React: SvgCallIcon3X,
          svgClassName: undefined,
          svg: __getSvg,
          bg: __getBg
        }
      );
      